import script from "./ProblemHandling.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProblemHandling.vue?vue&type=script&lang=ts&setup=true"

import "./ProblemHandling.vue?vue&type=style&index=0&id=fbe9b4d6&lang=scss&scoped=true"
import "./ProblemHandling.vue?vue&type=style&index=1&id=fbe9b4d6&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe9b4d6"]])

export default __exports__